module.exports = __webpack_public_path__ + "img/Free hand.5f79c0a0.png";